export default {
     API_ENDPOINT: 'https://shrouded-wave-72208.herokuapp.com/api',
     TOKEN_KEY: 'booknation-client-auth-token',
   }